import { defineMessages } from 'react-intl';

const messages = defineMessages({
  widgetTitle: {
    defaultMessage: 'Interactive walkthrough',
    id: 'WrS1fW',
  },
  widgetDescription: {
    defaultMessage: 'Description',
    id: 'Q8Qw5B',
  },
  slideMenuLabel: {
    defaultMessage: 'Menu',
    id: 'tKMlOc',
  },
  slideForwardLabel: {
    defaultMessage: 'Forward',
    id: 'RXpxPU',
  },
  slidePreviousLabel: {
    defaultMessage: 'Previous',
    id: 'JJNc3c',
  },
  slideRestartLabel: {
    defaultMessage: 'Restart',
    id: '5kK+j9',
  },
  slideNextStepsLabel: {
    defaultMessage: 'Next Steps',
    id: 'xe05Cm',
  },
  slide1Title: {
    defaultMessage: 'Carrier Report',
    id: 'uUdzMG',
  },
  slide1Description: {
    defaultMessage:
      'In this walk through, we will demonstrate how SevOne NPM enables you to collect data from different network elements of the Carrier world and display and analyze the data so that Carrier Service Providers (CSPs) can improve network performance and make smarter business decisions. <br /> <br /> This report displays a summary overview of alerts that can be filtered by: <br /><ul> <li>Severity</li> <li>Alerts per device</li> <li>The number of occurrences</li> <li>Full list of alerts</li> </ul>',
    id: 'rixTAw',
  },
  slide1NextStepsTitle: {
    defaultMessage: 'Click the Filters Bar',
    id: '97JXZA',
  },
  slide1ImageAlt: {
    defaultMessage: 'An overview of alerts from the Carrier Report',
    id: 'ioEPq2',
  },
  slide2Title: {
    defaultMessage: 'Breadcrumbs',
    id: 'ByoZDD',
  },
  slide2Description: {
    defaultMessage:
      'You can switch the filter to an array of different options to modify your visualization. You can filter your view for alerts by: <br /><ul> <li>Location</li> <li>Device groups</li> <li>Alert types</li> <li>Timeframe</li> </ul>',
    id: 'XaHmjF',
  },
  slide2NextStepsTitle: {
    defaultMessage: 'Click EnodeBLondon',
    id: 'MlKD01',
  },
  slide2ImageAlt: {
    defaultMessage: 'An overview of the filters',
    id: 'Mz0SbG',
  },
  slide3Title: {
    defaultMessage: 'Summary report',
    id: 'V1X0tX',
  },
  slide3Description: {
    defaultMessage:
      'This summary report provides you an overview of the device you have just selected. <br /><br /><ul> <li>Success rates</li> <li>Initial success rates</li> <li>Attempted rates</li></ul>',
    id: '1JL8AN',
  },
  slide3NextStepsTitle: {
    defaultMessage: 'Click RRC',
    id: 'vB72er',
  },
  slide3ImageAlt: {
    defaultMessage: 'An overview of the summary report for the selected device',
    id: 'mlU/D0',
  },
  slide4Title: {
    defaultMessage: 'RRC',
    id: 'YL/TZM',
  },
  slide4Description: {
    defaultMessage:
      'This part of the summary report gives you a summary of your devices connection establishment success rates & attempts.',
    id: 'dC4bKZ',
  },
  slide4NextStepsTitle: {
    defaultMessage: 'Click Handover',
    id: 'r4v69o',
  },
  slide4ImageAlt: {
    defaultMessage: 'An overview of the RRC tab for the selected device',
    id: 'nKnDzZ',
  },
  slide5Title: {
    defaultMessage: 'Handover',
    id: 'TCroxq',
  },
  slide5Description: {
    defaultMessage:
      'This part of the summary report gives you a summary of your devices handover success rates.',
    id: 'PAfHdI',
  },
  slide5NextStepsTitle: {
    defaultMessage: 'Click Carrier Report',
    id: 'FD8nW4',
  },
  slide5ImageAlt: {
    defaultMessage: 'An overview of the handover tab for the selected device',
    id: 'NZJzGT',
  },
  slide6Title: {
    defaultMessage: 'Carrier report',
    id: 'ys93rZ',
  },
  slide6Description: {
    defaultMessage:
      'Now that we’ve returned to carrier report, lets explore some of the other tabs and the visualisations that they provide.',
    id: '3TrgNF',
  },
  slide6NextStepsTitle: {
    defaultMessage: 'Click Tower',
    id: 'oEGR6h',
  },
  slide6ImageAlt: {
    defaultMessage: 'An overview of alerts for the carrier report',
    id: 'StXMf7',
  },
  slide7Title: {
    defaultMessage: 'Tower',
    id: 'vm+JOK',
  },
  slide7Description: {
    defaultMessage:
      'On this tab any device that was seen can be monitored, regardless of the technology. SNMP, API or even a manager that generates bulk files, as long as there is a way to collect the data, SevOne is capable of it. All of the data is shown & summarised through the visualisations you see here. If you only want to see a summary of a specific device, it’s as simple as selecting it to change your display. ',
    id: 'Tx3g5G',
  },
  slide7NextStepsTitle: {
    defaultMessage: 'Click Backhaul',
    id: 'SvpShY',
  },
  slide7ImageAlt: {
    defaultMessage: 'An overview of the Tower tab',
    id: 'BvV3+Z',
  },
  slide8Title: {
    defaultMessage: 'Backhaul',
    id: 'IEQHcm',
  },
  slide8Description: {
    defaultMessage:
      'This tab allows you to get metrics on the different protocols you may be utilizing.',
    id: 'uMHH5a',
  },
  slide8NextStepsTitle: {
    defaultMessage: 'Click Core',
    id: 'bgp9Be',
  },
  slide8ImageAlt: {
    defaultMessage: 'An overview of the Backhaul tab',
    id: 'mULOir',
  },
  slide9Title: {
    defaultMessage: 'Core',
    id: '2z6QCO',
  },
  slide9Description: {
    defaultMessage:
      'The core displays displays information for your whole network. It allows you to view either raw data for all your devices or create specific aggregations and view them in the different formats you see here.',
    id: 'zYS/2M',
  },
  slide9NextStepsTitle: {
    defaultMessage: 'Click Transit',
    id: '2lRua/',
  },
  slide9ImageAlt: {
    defaultMessage: 'An overview of the Core tab',
    id: 'NE+6BQ',
  },
  slide10Title: {
    defaultMessage: 'Transit',
    id: 'ZPFhvr',
  },
  slide10Description: {
    defaultMessage:
      'The transit tab allows you to monitor all of the traffic you are sending through each of your providers. the display shows all of your different ISP provides, interchanges, the traffic being sent through in the different visualizations you see here. Based on this you can can easily see which providers are generating the most or least traffic for you based on costs.',
    id: 'HZ2Mxq',
  },
  slide10NextStepsTitle: {
    defaultMessage: 'Click Health (COC)',
    id: '4Xg5OD',
  },
  slide10ImageAlt: {
    defaultMessage: 'An overview of the Transit tab',
    id: 'w9dCaW',
  },
  slide11Title: {
    defaultMessage: 'Health (CoC)',
    id: 'MXjPak',
  },
  slide11Description: {
    defaultMessage:
      'SevOne NPM also allows you to create your own metrics & custom indicators using existing metrics. This can be helpful in cases where your device is not automatically providing you the metrics you’re looking for. Using SevOne NPM you can use the available metrics to manually calculate the metrics you’re looking for.',
    id: '3rUD9A',
  },
  slide11NextStepsTitle: {
    defaultMessage: 'Click the SevOne Logo',
    id: 'zClEUR',
  },
  slide11ImageAlt: {
    defaultMessage: 'An overview of the Health (CoC) tab',
    id: 'Bny8Be',
  },
  slide12Title: {
    defaultMessage: 'Completed!',
    id: '9V3VBI',
  },
  slide12Description: {
    defaultMessage:
      'You’ve just seen some of the visualisations & dashboards that SevOne NPM provides its users. Book a demo of the product to see what else SevOne can offer you.',
    id: 'aV0vuA',
  },
  slide12NextStepsTitle: {
    defaultMessage: 'Click here to book a demo',
    id: 'Yc3eK4',
  },
  slide12ImageAlt: {
    defaultMessage: 'The IBM logo',
    id: 'g6y5nB',
  },
});

export default messages;
